import clsx from 'clsx';
import type * as React from 'react';

import type * as hiveCore from '@gitbook/hive-core';
import { PageLayoutOptionsWidth } from '@gitbook/hive-core';

import { usePageLayoutOptions } from '../../Space';

/**
 * Wrap the content of a page.
 * https://user-images.githubusercontent.com/8937991/236822645-feac21e1-76e0-40d0-bd94-013452187d8c.png
 */
export function PageWidthWrapper(props: {
    page: hiveCore.RevisionPageDocument;
    children: React.ReactNode;
    className?: string;
}) {
    const { width } = usePageLayoutOptions(props.page);

    return (
        <div
            className={clsx(
                'size-full shrink',
                width === PageLayoutOptionsWidth.Wide
                    ? 'page-full-width max-w-[--page-layout-wide-max-width]'
                    : 'max-w-[--page-layout-default-max-width]',
                props.className
            )}
        >
            {props.children}
        </div>
    );
}
